import { render, staticRenderFns } from "./majorBtn.vue?vue&type=template&id=2ad340c2&scoped=true&"
import script from "./majorBtn.vue?vue&type=script&lang=js&"
export * from "./majorBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad340c2",
  null
  
)

export default component.exports